import { trpc } from 'root/src/client/v2/trpc/trpc';
export const useBrandPrograms = () => {
    const query = trpc.ambassador.getBrandPrograms.useQuery();
    return {
        isLoading: query.isLoading,
        programs: query.data || [],
    };
};
